import { IFetchConfig } from "@elsa-zku/lib/helpers/fetch";
import fetch from "./http-client";

import { Employee, EmployeeFormType } from "./data-contracts";

export const getAppEmployeeGetall = (params?: IFetchConfig) => fetch<Employee[]>("GET", `employee`, null, params);

export const postAppEmployeeAddemployee = (data: EmployeeFormType, params?: IFetchConfig) =>
  fetch<Employee>("POST", `employee`, data, params);

export const getAppEmployeeGetbyid = (id: number, params?: IFetchConfig) =>
  fetch<Employee>("GET", `employee/${id}`, null, params);
